import { getEnvUrl,getToken,axiosInstance } from "../../utils/Api";
import axios from "axios";
export async function UserLogin(email, password) {
    try {
        const url = `${getEnvUrl()}/admin/systemUserLogin?email=${email}&password=${password}`;
        const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
        });
        return response;
    } catch (error) {
      console.error('Error occurred during login:', error);
      return false;
    }
  }

export const UserLogout = async (data) =>{
    localStorage.clear()
    return true;
}

export const checkPermissions = (key) => {
  let permissions = localStorage.getItem("permissions");
  if (!permissions) {
    return false;
  }
  try {
    permissions = JSON.parse(permissions);
    if (Array.isArray(permissions)) {
      const exists = permissions.find((item) => item.key === key) !== undefined;
      if (exists) {
        return true;
      }
    }
  } catch (error) {
    console.error("Error parsing permissions:", error);
  }
  return false;
}
export const fetchStates = async () => {
  try {
    const response = await axiosInstance.get('/admin/getStates', {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    });
    return response;
  } catch (error) {
    console.error('Error in Fetch States:', error);
    return false;
  }
};
export async function UserUpdatePermissions() {
  try {
    const response = await axios.get(`${getEnvUrl()}/admin/getUserPermissions`, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    });
    const res = response.data;
        if (res.status) {
        alert('Permissions updated successfully. Page is refreshing now.');
        localStorage.setItem('permissions', JSON.stringify(res.data.permissions));
        setTimeout(() => {
          window.location.reload();
        }, 100);
      } else {
        alert(res.errorMessage);
      }
  } catch (error) {
    alert(error.response ? error.response.statusText : error.message);
    return false;
  }finally {
    document.getElementById('clearcachespinner').style.display = 'all';
  }
};
  export const createUser = async (insertData) =>{ 
  try {
      const response = await axiosInstance.post("/admin/user/createUser",insertData,{
          headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${getToken()}`,
          }
      });
      return response.data;
    } catch (error) {
      throw error;
    } 
} 
  export const createOfflineUser = async (insertData) =>{ 
  try {
    const response = await axiosInstance.post("/admin/user/createOfflineUser",insertData,{
          headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${getToken()}`,
          }
      });
      return response.data;
    } catch (error) {
      throw error;
    } 
} 
  export const updateUser = async (insertData) =>{ 
  try {
      const response = await axiosInstance.put("/admin/user/updateUser",insertData,{
          headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${getToken()}`,
          }
      });
      return response.data;
    } catch (error) {
      throw error;
    } 
} 
  export const updateOfflineUser = async (insertData) =>{ 
  try {
    const response = await axiosInstance.put("/admin/user/updateOfflineUser",insertData,{
          headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${getToken()}`,
          }
      });
      return response.data;
    } catch (error) {
      throw error;
    } 
} 

export const getUserByID = async (userId) => {
try {
  const response = await axiosInstance.get(`/admin/user/getUser`, {
    params: { id: userId }, 
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  });
  return response.data;
} catch (error) {
  console.error('Error in get User By ID:', error);
  return false;
}
};
export const getOfflineUserByID = async (userId) => {
try {
  const response = await axiosInstance.get(`/admin/user/getOfflineUser`, {
    params: { id: userId }, 
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  });
  return response.data;
} catch (error) {
  console.error('Error in get User By ID:', error);
  return false;
}
};
export const deleteOfflineUserByID = async (deleteUserID) => {
  try {
    const response = await axiosInstance.put(
      `/admin/user/offlineUserDelete`,
      {
        user_id: deleteUserID,
        active: false
      },
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error in delete User:', error);
    return false;
  }
};